// Author: Kalyan Bikram Adhikari
// Created-Date:
// Modified-Date:

import React, { useEffect } from "react";
import { Formik } from "formik";
import * as Yup from "yup";
import Button from "../components/Button";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";

// toast
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { useForgotPasswordMutation } from "../store/APIFeatures/userAPIs";

// slices of toolkit

const ForgotPassword = () => {
  const dispatch = useDispatch();
  const [forgotPassword, { data, isLoading, isSuccess, status }] =
    useForgotPasswordMutation();
  const [showOldPassword, setShowOldPassword] = React.useState(false);
  const [showPassword, setShowPassword] = React.useState(false);

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const [showConfirmPassword, setShowConfirmPassword] = React.useState(false);
  const handleClickShowConfirmPassword = () => {
    setShowConfirmPassword(!showConfirmPassword);
  };
  const location = window.location.origin;
  // console.log('location', location)

  useEffect(() => {
    if (isSuccess) {
      toast.success("Password changed successfully!");
    }
    // if (status === 'rejected') {
    //     console.log('login failed')
    // }
  }, [isSuccess, status]);

  return (
    <div>
      <Formik
        initialValues={{
          email: "",
          regNumber: "",
          password: "",
          confirmpassword: "",
        }}
        validationSchema={Yup.object().shape({
          // username: Yup.string().max(255).required('Username is required'),
          email: Yup.string()
            .matches(
              /^(?:\d{10}|\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*)$/,
              "Must be a valid email "
            )
            .required("Email is required"),
          regNumber: Yup.string()
            .max(255)
            .required("Registration Number is required"),
          password: Yup.string()
            .required("Password is required")
            .min(6, "Password must be at least 6 characters long")
            .matches(
              /[A-Z]/,
              "Password must contain at least one uppercase letter"
            )
            .matches(
              /[a-z]/,
              "Password must contain at least one lowercase letter"
            )
            .matches(/[0-9]/, "Password must contain at least one digit")
            .matches(
              /[^a-zA-Z0-9]/,
              "Password must contain at least one non-alphanumeric character"
            )
            .matches(
              /^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[^a-zA-Z0-9]).{6,}$/,
              "Password must meet all requirements"
            ),
          confirmpassword: Yup.string()
            .oneOf([Yup.ref("password"), null], "Passwords must match")
            .max(255)
            .required("Confirm Password is required"),
        })}
        onSubmit={async ({ email, regNumber, password }) => {
          const isEmailSent = await forgotPassword({
            emailorphone: email,
            candidatenumber: regNumber,
            newpassword: password,
          });
          if ([400, 404].includes(isEmailSent.error.originalStatus)) {
            toast.error(isEmailSent.error.data);
          }
          // if (isLoggedIn) navigate('/');
        }}
      >
        {({
          errors,
          handleBlur,
          handleChange,
          handleSubmit,
          isSubmitting,
          touched,
          values,
        }) => {
          return (
            <form noValidate onSubmit={handleSubmit}>
              <div className="flex flex-col lg:h-screen md:flex-row">
                {/* left section of the login code */}
                <div className="flex flex-col  md:fixed md:h-screen md:left-0 md:w-1/2 md:p-8 md:gap-y-32 md:bg-primary-background ">
                  <Link to="/">
                    <div className="hidden md:block">
                      <img
                        src="/assets/images/Logo.png"
                        alt=""
                        className="h-16"
                      />
                    </div>
                  </Link>
                  <div className="flex justify-center items-center mb-6 mt-12 md:hidden w-full">
                    <span className="text-xl text-primary-title font-poppins font-semibold">
                      Forgot Password
                    </span>
                  </div>
                  <div className="flex justify-center items-center">
                    <img
                      src="/assets/images/login.png"
                      alt=""
                      className="h-60 md:h-80"
                    />
                  </div>
                </div>

                {/* right section of the login code */}

                <div className=" w-full md:w-1/2 md:ml-auto ">
                  <div className="md:mt-32 lg:px-32 xl:px-44 2xl:px-52 lg:p-10 p-4  md:space-y-10 ">
                    <div className=" text-primary-title font-poppins text-xl font-semibold hidden md:flex md:justify-center">
                      <span className="text-2xl">Forgot Password</span>
                    </div>
                    <div>
                      <div className="flex flex-col space-y-1 my-2 px-4  ">
                        <span className="font-poppins text-base">
                          Email{" "}
                          <span className=" text-red-600 font-medium text-xl">
                            *{" "}
                          </span>{" "}
                        </span>
                        <input
                          type="text"
                          id="email"
                          value={values.email}
                          name="email"
                          onBlur={handleBlur}
                          onChange={handleChange}
                          placeholder="Enter your email or phone Number"
                          className={`border-[1px] border-gray-400 p-1 h-10 px-2 rounded-lg outline-none ${
                            touched.email && errors.email
                              ? "border-red-500"
                              : "border-gray-400"
                          }`}
                        />
                        {touched.email && errors.email && (
                          <span error className="text-red-500">
                            {errors.email}
                          </span>
                        )}
                      </div>
                      <div className="flex flex-col space-y-1 my-2 px-4  ">
                        <span className="font-poppins text-base font-medium">
                          Registration Number{" "}
                          <span className=" text-red-600 font-medium text-xl">
                            *{" "}
                          </span>{" "}
                        </span>
                        <div className="relative">
                          <input
                            type={"text"}
                            id="regNumber"
                            value={values.regNumber}
                            name="regNumber"
                            onBlur={handleBlur}
                            onChange={handleChange}
                            placeholder="Enter your candidate registration number"
                            className={`border-[1px] border-gray-400 p-1 h-10 px-2 rounded-[5px] outline-none w-full ${
                              touched.regNumber && errors.regNumber
                                ? "border-red-500"
                                : "border-gray-400"
                            }`}
                          />
                        </div>

                        {touched.regNumber && errors.regNumber && (
                          <span
                            error
                            className="text-red-500 text-[14px] font-poppins"
                          >
                            {errors.regNumber}
                          </span>
                        )}
                      </div>
                      <div className="flex flex-col space-y-1 my-2 px-4  ">
                        <span className="font-poppins  text-base font-medium">
                          New Password{" "}
                          <span className=" text-red-600 font-medium text-xl">
                            *{" "}
                          </span>{" "}
                        </span>
                        <div className="flex relative border-[1px] border-gray-400  rounded-[5px] overflow-hidden">
                          <input
                            type={showPassword ? "text" : "password"}
                            id="password"
                            value={values.password}
                            name="password"
                            onBlur={handleBlur}
                            onChange={handleChange}
                            placeholder="Enter your password"
                            className={`p-1 font-poppins text-[14px] h-10 px-2 outline-none w-[90%]  ${
                              touched.password && errors.password
                                ? "border-red-500"
                                : "border-[#CED4DA]"
                            }`}
                          />
                          <div
                            className="right-0 pr-2 flex items-center cursor-pointer"
                            onClick={handleClickShowPassword}
                          >
                            {showPassword ? (
                              <RemoveRedEyeIcon className="w-5 h-5" />
                            ) : (
                              <VisibilityOffIcon className="w-5 h-5" />
                            )}
                          </div>
                        </div>

                        {touched.password && errors.password && (
                          <span
                            error
                            className="text-red-500 text-[14px] font-poppins"
                          >
                            {errors.password}
                          </span>
                        )}
                      </div>

                      {/* confirm password */}
                      <div className="flex flex-col space-y-1 my-2 px-4  ">
                        <span className="font-poppins text-base  font-medium">
                          Confirm Password{" "}
                          <span className=" text-red-600 font-medium text-xl">
                            *{" "}
                          </span>{" "}
                        </span>
                        <div className="flex relative border-[1px] border-gray-400  rounded-[5px] overflow-hidden">
                          <input
                            type={showConfirmPassword ? "text" : "password"}
                            id="confirmpassword"
                            value={values.confirmpassword}
                            name="confirmpassword"
                            onBlur={handleBlur}
                            onChange={handleChange}
                            placeholder="Re-enter your password"
                            className={`p-1 font-poppins text-[14px] h-10 px-2 outline-none w-[90%]  ${
                              touched.confirmpassword && errors.confirmpassword
                                ? "border-red-500"
                                : "border-[#CED4DA]"
                            }`}
                          />
                          <div
                            className="right-0 pr-2 flex items-center cursor-pointer"
                            onClick={handleClickShowConfirmPassword}
                          >
                            {showConfirmPassword ? (
                              <RemoveRedEyeIcon className="w-5 h-5" />
                            ) : (
                              <VisibilityOffIcon className="w-5 h-5" />
                            )}
                          </div>
                        </div>
                        {touched.confirmpassword && errors.confirmpassword && (
                          <span className="text-red-500 text-[14px] font-poppins">
                            {errors.confirmpassword}
                          </span>
                        )}
                      </div>

                      <div className=" p-4">
                        <Button
                          title="Change Password"
                          className="w-full rounded-md"
                        />
                      </div>
                      <div className="flex items-center px-4 ">
                        <hr className="flex-grow border-t border-gray-300" />
                        <span className="mx-4 text-gray-500">Or</span>
                        <hr className="flex-grow border-t border-gray-300" />
                      </div>

                      <div className="flex justify-center mt-6  ">
                        <span className="font-medium text-sm font-poppins ">
                          Go back to ?
                          <Link to="/">
                            <span className="font-poppins text-[#448eb6] font-medium text-sm ml-2">
                              Home
                            </span>
                          </Link>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          );
        }}
      </Formik>
    </div>
  );
};

export default ForgotPassword;
